import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SpaDataContext = createContext({ therapists: [], massages: [], spacePhotos: [], loading: true });

export const SpaDataProvider = ({ children }) => {
  const [state, setState] = useState({ therapists: [], massages: [], spacePhotos: [], loading: true });

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/therapists`),
      axios.get(`${API}/massages`),
      axios.get(`${API}/space-photos`).catch(() => ({ data: [] })),
    ])
      .then(([t, m, s]) =>
        setState({ therapists: t.data, massages: m.data, spacePhotos: s.data || [], loading: false }),
      )
      .catch((e) => {
        console.error("Failed to load spa data", e);
        setState((s) => ({ ...s, loading: false }));
      });
  }, []);

  return <SpaDataContext.Provider value={state}>{children}</SpaDataContext.Provider>;
};

export const useSpaData = () => useContext(SpaDataContext);
